const finite = (value, fallback = 0) => {
  const num = Number(value)
  return Number.isFinite(num) ? num : fallback
}

export const frameDurationForFps = (fps) => 1 / Math.max(1, finite(fps, 24))

export const timelineAdjacencyEpsilon = (fps = 24) =>
  Math.max(1e-6, frameDurationForFps(fps) / 100)

export const snapTimeToFrame = (time, fps = 24) => {
  const safeFps = Math.max(1, finite(fps, 24))
  const frame = Math.round(finite(time, 0) * safeFps)
  return frame / safeFps
}

export const snapTimelineTime = (time, {
  enabled = true,
  unit = 'quarter',
  fps = 24,
  beatCode = null,
} = {}) => {
  const raw = finite(time, 0)
  if (!enabled) return raw
  if (unit === 'frame') return snapTimeToFrame(raw, fps)

  const step = unit === 'quarter'
    ? beatCode?.secondsPerQuarter?.()
    : unit === 'eighth'
      ? beatCode?.secondsFor?.('eighth')
      : unit === 'half'
        ? beatCode?.secondsFor?.('half')
        : unit === 'whole'
          ? beatCode?.secondsFor?.('whole')
          : unit === 'sixteenth'
            ? beatCode?.secondsFor?.('sixteenth')
            : beatCode?.secondsPerQuarter?.()

  const safeStep = finite(step, 0)
  if (!(safeStep > 0)) return raw
  const bucket = Math.round(raw / safeStep)
  return bucket * safeStep
}

export const rangesOverlap = (startA, lengthA, startB, lengthB, eps = timelineAdjacencyEpsilon()) => {
  const a0 = finite(startA, 0)
  const a1 = a0 + Math.max(0, finite(lengthA, 0))
  const b0 = finite(startB, 0)
  const b1 = b0 + Math.max(0, finite(lengthB, 0))
  const safeEps = Math.max(0, finite(eps, timelineAdjacencyEpsilon()))
  return a0 < b1 - safeEps && b0 < a1 - safeEps
}

export const timesEffectivelyEqual = (a, b, eps = timelineAdjacencyEpsilon()) =>
  Math.abs(finite(a, 0) - finite(b, 0)) <= Math.max(0, finite(eps, timelineAdjacencyEpsilon()))
